import React from 'react';
import Ubivox from './ubivox';
import ChangePassword from 'containers/settings/changePassword';
import './generalSettings.css';

const GeneralSettings = ({translate, subscribedToNewsletter, changeToggle}) => (
  <div className="general-settings">
    <div className="u-m-b-40">
      <h3 className="text-center text-green">Indstillinger for din profil og konto</h3>
    </div>
    <div className="general-settings__box">
      <div className="general-settings__item">
        <Ubivox
          translate={translate}
          subscribedToNewsletter={subscribedToNewsletter}
          changeToggle={changeToggle}
        />
      </div>
      <div className="general-settings__item">
        <ChangePassword
          translate={translate}
        />
      </div>
    </div>
  </div>
);

export default GeneralSettings;



// WEBPACK FOOTER //
// ./src/components/main/settings/generalSettings.js